import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-work-modern',
  templateUrl: './page-work-modern.component.html',
  styleUrls: ['./page-work-modern.component.css']
})
export class PageWorkModernComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }


}
